var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"page-attention"},[_c('div',{staticClass:"row-space-tbf"},[_c('div',{staticClass:"space-left"}),_c('not-found'),_c('div',{staticClass:"space-right"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }